<template>
	<popup-dialog :full-width="true" :popup-active="popupStatus">
		<i @click="popupClose" class="fas fa-times popup-close"></i>
		<div class="popup popup--settings bg--white">
			<div class="popup__content scrollbar-custom">
				<quizzes-list
					@chosen-quiz="getChosenQuiz"
				></quizzes-list>
			</div>
		</div>
	</popup-dialog>
</template>

<script>
import PopupDialog from "@/components/ui/popup/PopupDialog";
import QuizzesList from "@/components/editor-options/settings/popup/content/quiz/QuizzesList";
export default {
	components: {QuizzesList, PopupDialog},
	props:{
		popupStatus: {
			type: Boolean,
			default: false
		},
	},
	emits: ['chosenQuiz'],
	setup(props, {emit}) {
		
		function popupClose(){
			emit('popupClose');
		}
		
		function getChosenQuiz({id, url, title}){
			emit('chosenQuiz', {id, url, title})
		}
		return {
			popupClose,
			getChosenQuiz,
		}
	}
}
</script>

<style lang="scss">

</style>